var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSocialGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-social-google",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_386",
    "data-name": "Rectangle 386",
    width: 28,
    height: 28,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M58.068,41.282l-.113-.47H47.546v4.322h6.219a6.208,6.208,0,0,1-6.089,4.591,7.362,7.362,0,0,1-4.9-1.916,6.8,6.8,0,0,1-2.087-4.844A6.688,6.688,0,0,1,47.6,36.259a6.414,6.414,0,0,1,4.142,1.583l3.131-3.055A11.177,11.177,0,0,0,47.5,32a11.52,11.52,0,0,0-8.069,3.219,11.027,11.027,0,0,0-3.184,7.754A10.9,10.9,0,0,0,39.311,50.6a11.793,11.793,0,0,0,8.418,3.351,10.485,10.485,0,0,0,7.563-3.119,10.839,10.839,0,0,0,2.9-7.588A12.358,12.358,0,0,0,58.068,41.282Z",
    transform: "translate(-33.224 -28.975)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSocialGoogle);
export default __webpack_public_path__ + "static/media/icon-social-google.e5fcd3e6a400ca3f4ced06e049784487.svg";
export { ForwardRef as ReactComponent };